import { FC } from 'react';

import { ENPS_PERFORMANCE_CARD_TEST_IDS } from '../../../constants/data-testids';
import { Card, CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

export const EnpsPerformanceCardSkeleton: FC = () => {
  return (
    <Card
      data-testid={ENPS_PERFORMANCE_CARD_TEST_IDS.SKELETON}
      className="select-none rounded-xl border-custom-warm-grey-100 bg-white p-4"
    >
      <CardContent className="flex flex-col gap-6">
        <header className="flex flex-col gap-2">
          <div className="flex min-h-5 items-center justify-between gap-2">
            <Skeleton className="h-[14px] w-[188px] rounded-sm" />
            <Skeleton className="h-4 w-10 rounded-sm" />
          </div>
          <div className="flex flex-col gap-0.5">
            <div className="flex min-h-6 items-center gap-1.5">
              <Skeleton className="h-[20px] w-[44px] rounded-sm" />
              <Skeleton className="h-[19px] w-[19px] rounded-sm" />
            </div>
            <div className="flex min-h-6 items-center gap-1.5">
              <Skeleton className="h-[14px] w-[30px] rounded-sm" />
              <Skeleton className="h-[14px] w-[200px] rounded-sm" />
            </div>
          </div>
        </header>
        <Skeleton className="mb-[-11px] h-3 w-full rounded-full" />
      </CardContent>
    </Card>
  );
};
